<template>
  <el-dialog
    title="Promoção não aplicável"
    :visible="visible"
    :show-close="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="420px"
  >
    <p class="promo-rejected-msg">{{ message }}</p>
    <span slot="footer" class="dialog-footer">
      <el-button
        v-if="hasOtherProducts"
        type="primary"
        style="width: 100%; margin: 0 0 8px;"
        @click="$emit('continue')"
      >
        Continuar compra <i class="el-icon-arrow-right"></i>
      </el-button>
      <el-button
        style="width: 100%; margin: 0;"
        @click="$emit('backToStore')"
      >
        <i class="el-icon-arrow-left"></i> Voltar para a loja
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
const MESSAGES = {
  bin_ineligible: 'O Journal de Dois Modos foi criado como um benefício exclusivo para clientes Nubank Ultravioleta. No momento, não identificamos um Cartão Black Ultravioleta ativo vinculado ao seu acesso.',
  payment_method: 'O Journal de Dois Modos é um benefício exclusivo para pagamentos realizados com Cartão de Crédito Nubank Ultravioleta. Selecione o cartão de crédito como forma de pagamento para utilizar esta promoção.',
  cpf_used: 'Este benefício já foi utilizado pelo seu CPF. A promoção é válida para uma única utilização por CPF.'
}

export default {
  name: 'MhStudiosPromoRejectedModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    hasOtherProducts: {
      type: Boolean,
      default: false
    },
    reason: {
      type: String,
      default: null
    }
  },
  computed: {
    message () {
      return MESSAGES[this.reason] || 'Você não é elegível para esta promoção. O produto promocional foi removido do seu carrinho.'
    }
  }
}
</script>

<style scoped>
.promo-rejected-msg {
  text-align: center;
  margin: 0;
  line-height: 1.6;
  overflow-wrap: break-word;
  word-break: keep-all;
}
</style>
